<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>{{ condition ? 'lblEditCheckListItem' : 'lblAddCheckListItem'}}</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>

      <form [formGroup]="addCheckListItemForm" (ngSubmit)="onSubmit()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-6 af-form-group" id="dealerList">
                  <label translate>lblChecklistName</label>
                  <div class="lbl-info font-15">
                    {{subCheckListTitle}}
                  </div>
                </div>

                <div class="col-6 af-form-group">
                  <label for="name" translate>lblSequence<strong
                    class="mlt6 required"> * </strong></label>
                  <div class='lbl-info'>
                    <input formControlName="sequence" class="form-control mb-2"
                      placeholder="{{ 'lblSequence' | translate }}" required pattern="^[0-9]{1,7}$">
                    <div *ngIf="cpf.sequence.invalid && (cpf.sequence.dirty || cpf.sequence.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.sequence.errors.pattern"><span translate>lblProperValue</span>
                      </div>
                      <div *ngIf="cpf.sequence.errors.min" translate>
                        lblMinimumRequiredNumber
                      </div>
                      <div *ngIf="cpf.sequence.errors.max" translate>
                        lblMaximunRequiredNumber
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 af-form-group">
                  <div class="row" *ngIf="t">
                    <div class="col-6" *ngFor="let ticket of t.controls; let i = index">
                      <div class="" [formGroup]="ticket">
                        <div class=" af-form-group">
                          <label for="name"><span translate>lblChecklistItemName</span>&nbsp;<span
                              translate>lblIn</span><span>
                              {{languageList[i].value}}</span>
                            <strong class="mlt6 required"> * </strong> </label>
                          <div class="lbl-info">
                            <input formControlName="name" class="form-control mb-2" maxlength="100">
                            <div *ngIf="cpf.service.touched && (cpf.service.errors?.required)"
                              class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                                aria-hidden="true"></em>
                              lblCheckListNameRequired
                            </div>
                          </div>
                        </div>

                        <div class="col-6 af-form-group" style="display: none;">
                          <label for="languageId" translate>Language Id</label>
                          <div class="lbl-info">
                            <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                              maxlength="30">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 af-form-group">
                  <label class="text" for="name" translate>lblChecklistType</label>
                  <div class="row">
                    <div class='col-auto lbl-info'>
                      <div class="form-check pl-0">
                        <label class="text" for="textBox" translate>
                          <input type="checkbox" name="textBox" id="textBox" formControlName="textBox"
                          class="">
                          lblTextBox
                        </label>
                      </div>
                    </div>
                    <div class='col-auto lbl-info'>
                      <div class="form-check pl-0">
                        
                        <label class="text" for="checkBox" translate>
                          <input type="checkbox" name="checkBox" formControlName="checkBox" id="checkBox"
                          class="">
                          lblCheckBox
                        </label>
                      </div>
                    </div>
                    <div class='col-auto lbl-info'>
                      <div class="form-check pl-0">
                        
                        <label class="text " for="radioButton" translate>
                          <input type="checkbox" name="radioButton" formControlName="radioButton" id="radioButton"
                          class="">
                          lblRadioButton
                        </label>
                      </div>
                    </div>
                    <div class='col-auto lbl-info'>
                      <div class="form-check pl-0">
                        
                        <label class="text " for="isQuestionActive" translate>
                          <input type="checkbox" name="isQuestionActive" id="isQuestionActive"
                          formControlName="isQuestionActive" class="">
                          lblQuestionActive
                          <span>?</span>
                        </label>
                      </div>
                    </div>
                    <div class='col-auto lbl-info'>
                      <div class="form-check pl-0">
                        
                        <label class="text " for="makeCameraAvailable"
                          translate>
                          <input type="checkbox" name="makeCameraAvailable" id="makeCameraAvailable"
                          formControlName="camaraAvailable" class="">
                          lblMakeCameraAvailable
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Checkbox -->
                <div class="col-12" *ngIf="addCheckListItemForm.value.checkBox">
                  <hr />
                  <h4 class="font-15 text-bold mb-2" translate>lblCheckBox</h4>
                  <div class="row">
                    <div class="w-100 px-0" *ngIf="c">

                      <div *ngFor="let ticket of c.controls; let i = index">
                        <div [formGroup]="ticket">
                          <div class="col-6 af-form-group">
                            <label for="name"><span translate>lblCheckBoxTitle</span><span>&nbsp;<span
                                  translate>lblIn</span>
                                {{languageList[i].value}}</span>
                              <strong class="mlt6 required"> * </strong> </label>
                            <div class="lbl-info">
                              <input formControlName="name" class="form-control mb-2" maxlength="100">
                            </div>
                          </div>

                          <div class="col-6 af-form-group" style="display: none;">
                            <label for="languageId" translate>Language Id</label>
                            <div class="lbl-info">
                              <input formControlName="languageId" class="form-control mb-2"
                                [ngModel]="languageList[i].id" maxlength="30">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class='col-12 af-form-group text-right'>
                      <div class="lbl-info">
                        <input type="button" class="btn btn-primary" value="{{ 'lblAdd' | translate }}"
                          (click)="addCheckBox()"
                          [disabled]="addCheckListItemForm.controls.checkbox.status === 'INVALID'">
                      </div>
                    </div>
                    <div class="col-12" *ngIf="addCheckListItemForm.value.checkBox && checkboxTitleList.length > 0">
                      <div class="table-responsive">
                        <table class="tablest1">
                          <thead *ngIf="languageList && languageList.length > 0">
                            <tr>
                              <th scope="col" translate *ngFor="let lan of languageList; let i = index">
                                <span translate>lblTitle</span>&nbsp;<span translate>lblIn</span>
                                {{lan.value}}
                              </th>
                              <th style="width: 75px" class="text-center" scope="col" translate>lblAction</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of checkboxTitleList" style="cursor: pointer;" class="color">
                              <td
                                *ngFor="let checkbox of item.checkListGroupItemCheckboxDetailsViewModel[0].checkboxTitle; let i = index">
                                <ngb-highlight [result]="checkbox.name" [term]="pService.searchTerm">
                                </ngb-highlight>
                              </td>
                              <td class="text-center">
                                <em class="far fa-trash-alt fa-lg" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                  (click)="deleteCheckBox(item.id)"></em>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="col-12" *ngIf="editMode">
                      <div class="table-responsive" *ngIf="isCheckBoxItem">
                        <table class="tablest1">
                          <thead *ngIf="languageList && languageList.length > 0">
                            <tr>
                              <th scope="col" translate *ngFor="let lan of languageList; let i = index">
                                <span translate>lblTitle</span>&nbsp;<span translate>lblIn</span>
                                {{lan.value}}
                              </th>
                              <th style="width: 75px" class="text-center" scope="col" translate>lblAction</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let checkBoxDetails of checkBoxList.checkBoxList; let i= index "
                              style="cursor: pointer;">
                              <ng-container *ngIf="!checkBoxDetails[0].isDeleted">
                              <td *ngFor="let lan of languageList; let k = index">
                                <span *ngFor="let c of checkBoxDetails; let j=index">
                                  <span *ngIf="lan.id === c.languageId">
                                    {{c.name}}
                                  </span>
                                </span>
                              </td>
                              <td class="text-center">
                                <em class="far fa-trash-alt fa-lg" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                  (click)="deleteCheckBoxInEditMode(i)"></em>
                              </td>
                            </ng-container>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Radio Button -->
                <div class="col-12" *ngIf="addCheckListItemForm.value.radioButton">
                  <hr />
                  <h4 class="font-15 text-bold mb-2" translate>lblRadioButton</h4>
                  <div class="row">
                    <div class="w-100 px-0" *ngIf="r">
                      <div *ngFor="let ticket of r.controls; let i = index">
                        <div [formGroup]="ticket">
                          <div class="col-6 af-form-group">
                            <label for="name"><span translate>lblRadioButtonTitle</span><span>&nbsp;<span
                                  translate>lblIn</span>
                                {{languageList[i].value}}</span>
                              <strong class="mlt6 required"> * </strong> </label>
                            <div class="lbl-info">
                              <input formControlName="name" class="form-control mb-2" maxlength="100">
                            </div>
                          </div>

                          <div class="col-6 af-form-group" style="display: none;">
                            <label for="languageId" translate>Language Id</label>
                            <div class="lbl-info">
                              <input formControlName="languageId" class="form-control mb-2"
                                [ngModel]="languageList[i].id" maxlength="30">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 af-form-group text-right">
                      <div class="lbl-info">
                        <input type="button" class="btn btn-primary" value="{{ 'lblAdd' | translate }}"
                          (click)="addRadioButton()"
                          [disabled]="addCheckListItemForm.controls.radio.status === 'INVALID'">
                      </div>
                    </div>

                    <div class="col-12"
                      *ngIf="addCheckListItemForm.value.radioButton && radiobuttonTitleList.length > 0">
                      <div class="table-responsive">
                        <table class="tablest1">
                          <thead *ngIf="languageList && languageList.length > 0">
                            <tr>
                              <th scope="col" translate *ngFor="let lan of languageList; let i = index">
                                <span translate>lblTitle</span>&nbsp;<span translate>lblIn</span>
                                {{lan.value}}
                              </th>
                              <th style="width: 75px" class="text-center" scope="col" translate>lblAction</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let item of radiobuttonTitleList" style="cursor: pointer;" class="color">
                              <td
                                *ngFor="let radio of item.checkListGroupItemRadiobuttonDetailsViewModel[0].radioTitle; let i = index">
                                <ngb-highlight [result]="radio.name" [term]="pService.searchTerm">
                                </ngb-highlight>
                              </td>
                              <td class="text-center">
                                <em class="far fa-trash-alt fa-lg" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                  (click)="deleteRadioButton(item.id)"></em>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="col-12" *ngIf="editMode">
                      <div class="table-responsive" *ngIf="isRadioButtonItem">
                        <table class="tablest1">
                          <thead>
                            <tr>
                              <th scope="col" translate *ngFor="let lan of languageList; let i = index">
                                <span translate>lblTitle</span>&nbsp;<span translate>lblIn</span>
                                {{lan.value}}
                              </th>
                              <th style="width: 75px" class="text-center" scope="col" translate>lblAction</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let radioButtonDetails of radioBtnList.radioBtnList; let i= index "
                              style="cursor: pointer;">
                              <ng-container *ngIf="!radioButtonDetails[0].isDeleted">
                              <td *ngFor="let lan of languageList; let k = index">
                                <span *ngFor="let c of radioButtonDetails; let j=index">
                                  <span *ngIf="lan.id === c.languageId">
                                    {{c.name}}
                                  </span>
                                </span>
                              </td>
                              <td class="text-center">
                                <em class="far fa-trash-alt fa-lg" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                  (click)="deleteRadioButtonInEditMode(i)"></em>
                              </td>
                            </ng-container>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Camera -->
                <div class="col-12 af-form-group" *ngIf="addCheckListItemForm.value.camaraAvailable">
                  <hr />
                  <h4 class="font-15 text-bold mb-2" translate>lblMakeCameraAvailable</h4>
                  <div class='lbl-info'>
                    <input type="text" class="form-control mb-2" formControlName="photoGraphyDetails"
                      placeholder="{{ 'lblPhotographyGuid' | translate }}" required>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button class="btn btn-primary mr-sm-2 btn-lg" translate aria-label="Center Align" *ngIf="condition" [disabled]="addCheckListItemForm.controls.sequence.errors!==null">
                <em class="far fa-save  font16 align-top mr-2"></em>
               lblSaveChanges
              </button>
              <button class="btn btn-primary mr-sm-2 btn-lg" translate aria-label="Center Align" *ngIf="!condition" [disabled]="addCheckListItemForm.controls.sequence.errors!==null">
                <em class="fa fa-plus  font16 align-top mr-2"></em>
               lblAdd
              </button>
              <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>